import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Typography } from '@/components/Typography';
import { theme } from '@/theme';

export const Wrapper = styled(Box)<{ $disabled?: boolean }>`
  text-align: center;
  margin: ${theme.space.s200} auto;
  ${({ $disabled, theme }) =>
    css`
      ${theme.media.sm.up} {
        padding: ${theme.spacing(0, 2)};
      }
      ${$disabled &&
      css`
        opacity: 0.4;
        pointer-events: none;
      `}
    `}
`;

export const StyledTable = styled.table`
  text-align: left;
  border-collapse: collapse;
  border-left: none;
  border-right: none;
  margin: 0 auto;
  width: 100%;
  padding-top: 2em;
  td {
    padding: 0.4em 4rem 0.3em 0;
  }
  td:last-child {
    padding-right: 0;
    text-align: right;
  }
`;

export const Disclaimer = styled(Typography)`
  margin: ${theme.space.s200} auto auto;
  font-size: ${theme.fontSizes.p3};
  color: ${theme.colors.secondaryGrey};
  line-height: ${theme.spacing(2.5)};
  text-align: center;
`;

export const V12LoanCalculatorCTAWrapper = styled(Typography)`
  padding: ${theme.space.s100};
  width: 100%;
  ${({ theme }) =>
    css`
      ${theme.media.md.up} {
        width: 183px;
      }
    `}
`;

export const ErrorMessage = styled(Typography)`
  color: red;
  margin: ${theme.spacing(2, 0)};
`;

export const CheckboxWrapper = styled(Box)`
  background: ${theme.colors.feedbackHighLight};
  color: ${theme.colors.black};
  padding: ${theme.spacing(2)};
  margin: ${theme.spacing(2, 0, 0)};
`;

export const InstallmentSummaryWrapper = styled(Box)`
  background: ${theme.colors.lightGrey};
  padding: ${theme.spacing(2)};
  tr.bold {
    font-weight: bold;
  }
  td {
    text-transform: uppercase;
    font-size: ${theme.fontSizes.h5Mobile};
    font-family: ${theme.fontFamilies.italianPlate};
  }
  ${({ theme }) =>
    css`
      ${theme.media.sm.up} {
        padding: ${theme.spacing(4, 4)};
        font-size: ${theme.fontSizes.h5};
      }
    `}
`;
